export enum RoleRestriction {
  OPERATOR = 'operador',
  COMMERCE = 'comercio',
  SUPERVISOR_EXTERNAL_PICKUP = 'external_pickup',
  EXTERNAL_OPERATOR = 'external_operator',
}

export const RoleRestrictionLabels: Record<RoleRestriction, string> = {
  [RoleRestriction.OPERATOR]: 'Operador',
  [RoleRestriction.COMMERCE]: 'Comercio',
  [RoleRestriction.SUPERVISOR_EXTERNAL_PICKUP]: 'External pickup',
  [RoleRestriction.EXTERNAL_OPERATOR]: 'Operador Externo',
};
